<template>
  <div
    id="app"
    :class="{ index_bg:this.$route.path=='/index',ceo_page:this.$route.path=='/ceo'&&isMobile }"
  >
    <!-- <Header/> -->
    <new-header/>
    <transition>
      <router-view/>
    </transition>
    <!-- <mobile-connect v-if="this.$route.path!=='/index'&&isMobile"/>
    <pc-connect v-if="this.$route.path!=='/index'&&!isMobile"/> -->
  </div>
</template>

<script>
import Header from "./components/of_header";
import NewHeader from "./components/new_header";
import MobileConnect from "./components/mobile_connect";
import PcConnect from "./components/pc_connect";
export default {
  name: "app",
  components: {
    Header,
    MobileConnect,
    PcConnect,
    NewHeader
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      isMobile: false //小尺寸屏幕
    };
  },
  mounted() {
    const that = this;
    if (that.screenWidth <= 900) {
      that.isMobile = true;
    } else {
      that.isMobile = false;
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        if (that.screenWidth <= 900) {
          that.isMobile = true;
        } else {
          that.isMobile = false;
        }
      })();
    };
  },
  watch: {
    $route() {
      document.title = this.$route.meta.title || this.$route.name;
    }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-decoration: none;
}
html,
body,
#app {
  height: 100%;
  position: relative;
}
/* .ceo_page {
  height: auto !important;
  padding-bottom: 200px;
} */
.index_bg {
  background: url("./assets/images/index_bg.png") center repeat;
  background-size: cover;
}
</style>
